import { Container, Typography } from "@material-ui/core"
import { useRouter } from "next/router"
import styled from "styled-components"
import colors from "theme/colors"
import loader from "../../public/animation/glass.json"

import GenericButton from "components/GenericButton/GenericButton"
import dynamic from "next/dynamic"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledLoadingContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  position: relative;
  padding-bottom: 140px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-bottom: 0px;
    padding-top: 100px;
  }
`
const StyledLottie = styled(Lottie)`
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: -100px;
  }
`
const StyledTitle = styled(Typography).attrs({
  component: "h1",
  variant: "h1",
})`
  color: ${colors.black};
  white-space: nowrap;
  font-size: 40px;
  line-height: 0.6;
  font-family: Speedee, NarkisBlock, sans-serif;
  margin-bottom: 20px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 8px;
    font-size: 50px;
  }
`
const StyledExplanation = styled(Typography).attrs({
  variant: "body1",
})`
  font-size: 24px;
  font-weight: 100;
  line-height: 1.2;
  text-align: right;
  margin-bottom: 40px;
  text-align: center;

  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 20px;
    padding: 0 40px;
  }
`

const StyledGenericButton = styled(GenericButton)`
  margin-bottom: 40px;
`

const ErrorLoadingAiPage = () => {
  const router = useRouter()

  const { type } = router.query

  const getErrorMessage = () => {
    switch (type) {
      case "specific":
        return " נראה שעברת את מכסת תמונות ה- AI שלך, אפשר לבחור תמונה קיימת או לנסות בעוד מספר שעות שוב."
      case "general":
        return " אופס יש כרגע בעיה זמנית לשלוח גיפטקארד Ai, אפשר לשלוח גיפטקארד אחר במקום :) "
      default:
        return " אופס יש כרגע בעיה זמנית לשלוח גיפטקארד Ai, אפשר לשלוח גיפטקארד אחר במקום :) "
    }
  }

  return (
    <StyledLoadingContainer>
      <StyledLottie animationData={loader} loop={true} />

      <StyledTitle>אופסי, משהו השתבש...</StyledTitle>
      <StyledExplanation>{getErrorMessage()}</StyledExplanation>
      <StyledGenericButton
        btnType="filled"
        onClick={() => router.push("/create-ai/choose-picture")}
        mobileWidth={200}
        width={200}
      >
        חזרה
      </StyledGenericButton>
    </StyledLoadingContainer>
  )
}

export default ErrorLoadingAiPage
